import { Helmet } from "react-helmet-async";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import BentoCapabilities from "../components/BentoCapabilities";
import CapabilitiesTabs from "../components/CapabilitiesTabs";
import MaterialsMatrix from "../components/MaterialsMatrix";
import SupplyChain from "../components/SupplyChain";
import RFQForm from "../components/RFQForm";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";
import SEO from "../components/SEO";
import { tc, tb } from "../lib/themeStyles";

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Contract Manufacturing",
  provider: {
    "@type": "Organization",
    name: "Malunjkar Engineering Company",
  },
  areaServed: "Worldwide",
  description:
    "Precision CNC machining, sheet metal fabrication, and heavy welding for international clients",
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Manufacturing Capabilities",
    itemListElement: [
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "CNC Fiber Laser Cutting" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Precision Machining" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Sheet Metal Fabrication" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "MIG/TIG Welding" } },
    ],
  },
};

export default function Home() {
  return (
    <div className="min-h-screen" style={{ ...tb.page, ...tc.primary }}>
      <SEO />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
      </Helmet>
      <Navbar />
      <main>
        <Hero />
        <BentoCapabilities />
        <CapabilitiesTabs />
        <MaterialsMatrix />
        <SupplyChain />
        <RFQForm />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
